import React from "react";
import { string, number } from "prop-types";

const YoutubeIcon = ({ color = "#949494", width = "28", height = "28" }) => (
  <svg width={width} height={height} viewBox="0 0 24 24">
    <path
      fill={color}
      d="M21.543,6.498C22,8.28,22,12,22,12s0,3.72-0.457,5.502c-0.254,0.985-0.997,1.76-1.938,2.022
	C17.896,20,12,20,12,20s-5.893,0-7.605-0.476c-0.945-0.266-1.687-1.04-1.938-2.022C2,15.72,2,12,2,12s0-3.72,0.457-5.502
	c0.254-0.985,0.997-1.76,1.938-2.022C6.107,4,12,4,12,4s5.896,0,7.605,0.476C20.55,4.742,21.292,5.516,21.543,6.498z M10,15.5l6-3.5
	l-6-3.5V15.5z"
    />
  </svg>
);

YoutubeIcon.propTypes = {
  color: string,
  width: number,
  height: number,
};

export default YoutubeIcon;
